'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/hero-slider');

require('../sections/featured-products');

require('../sections/app');

require('../sections/testimonials');

(0, _themeSections.load)('*');